import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSundeck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 68,
	viewBox: "0 0 69 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M34.2847 9.99805C33.7347 9.99805 33.2847 7.97305 33.2847 5.49805C33.2847 3.02305 33.7347 0.998047 34.2847 0.998047C34.8347 0.998047 35.2847 3.02305 35.2847 5.49805C35.2847 7.97305 34.8347 9.99805 34.2847 9.99805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6177 17.331C15.8807 18.068 10.2847 13.1901 10.2847 11.8111C10.2847 10.2541 11.9277 11.016 14.6117 13.817C16.0977 15.368 16.9997 16.949 16.6177 17.331Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6177 17.6651C51.2397 17.2871 52.2197 15.6321 53.7947 13.9881C56.6237 11.0341 58.2847 10.2291 58.2847 11.8111C58.2847 13.1851 52.3497 18.3961 51.6177 17.6651Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.78467 35.998C2.30967 35.998 0.284668 35.548 0.284668 34.998C0.284668 34.448 2.30967 33.998 4.78467 33.998C7.25967 33.998 9.28467 34.448 9.28467 34.998C9.28467 35.548 7.25967 35.998 4.78467 35.998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.7847 35.998C61.3097 35.998 59.2847 35.548 59.2847 34.998C59.2847 34.448 61.3097 33.998 63.7847 33.998C66.2597 33.998 68.2847 34.448 68.2847 34.998C68.2847 35.548 66.2597 35.998 63.7847 35.998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6177 58.6651C10.2397 58.2871 11.2197 56.6321 12.7947 54.9881C15.6237 52.0341 17.2847 51.2291 17.2847 52.8111C17.2847 54.1851 11.3497 59.3961 10.6177 58.6651Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9517 58.6651C57.2197 59.3961 51.2847 54.1851 51.2847 52.8111C51.2847 51.2291 52.9457 52.0341 55.7747 54.9881C57.3497 56.6321 58.3297 58.2871 57.9517 58.6651Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.2847 67.998C33.7347 67.998 33.2847 65.973 33.2847 63.498C33.2847 61.023 33.7347 58.998 34.2847 58.998C34.8347 58.998 35.2847 61.023 35.2847 63.498C35.2847 65.973 34.8347 67.998 34.2847 67.998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.0437 13.364C22.7907 15.319 19.8027 17.4421 16.9747 21.2271C5.91967 36.0291 16.3517 56.954 34.7847 56.954C49.5797 56.954 60.3017 42.845 56.3187 28.619C53.0177 16.829 39.0217 9.27804 28.0437 13.364ZM55.2627 34.552C55.2177 26.19 48.4817 17.257 40.5617 15.058C33.1107 12.989 26.2087 14.741 20.6717 20.107C11.4687 29.028 12.6837 44.063 23.2097 51.498C26.9837 54.164 28.2637 54.498 34.6937 54.498C40.8707 54.498 42.5247 54.105 45.9847 51.815C50.9457 48.532 55.2947 40.441 55.2627 34.552ZM28.9687 18.4021C23.9617 20.2471 21.4067 22.618 19.1657 27.498C16.9637 32.292 16.7947 36.918 18.6617 41.28C21.1657 47.132 28.1327 52.099 33.5997 51.931C34.8017 51.893 33.6347 51.285 31.0057 50.578C20.1997 47.672 15.4907 37.401 20.3557 27.351C23.8457 20.142 31.8267 16.9811 40.7847 19.2621C42.8957 19.7991 43.3117 19.736 42.1887 19.048C39.2847 17.27 32.8887 16.9571 28.9687 18.4021ZM44.2847 20.998C44.2847 21.548 44.7617 21.998 45.3437 21.998C45.9257 21.998 46.1247 21.548 45.7847 20.998C45.4447 20.448 44.9687 19.998 44.7257 19.998C44.4827 19.998 44.2847 20.448 44.2847 20.998ZM41.2847 49.998C40.3837 50.58 40.2597 50.973 40.9757 50.983C41.6307 50.991 42.4447 50.548 42.7847 49.998C43.5517 48.756 43.2057 48.756 41.2847 49.998Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgSundeck);
export { ForwardRef as ReactComponent };
